var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraStep = function SvgCameraStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.263,
    d: "M39.026 41.4 32.5 43.217l-8.033 2.236-4.598-5.665V58.35L3.158 48.7v-5.476l11.937 6.89v-16.3L3.815 19.836 12.171 8.09l4.326 5.362 20.684 25.661z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.263,
    d: "m51.24 38.607-12.632 6.316-6.107 1.68-2.248.62 2.248-1.125 10.383-5.192z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.263,
    d: "m43.743 51.315-8.299 2.33-2.943-3.643-2.248-2.78 2.248-.618 6.108-1.68z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.263,
    d: "m32.5 46.099-2.248 1.124 2.249 2.779v2.033l-12.632 6.316V39.79l4.598 5.665 8.034-2.236zM51.657 35.083l-12.632 6.316-1.844-2.287-20.684-25.66-4.326-5.363 12.631-6.316zM56.375 44.999l-12.632 6.316-5.135-6.392 12.632-6.316zM15.095 37.255v12.86L3.158 43.223z"
  })));
};
export default SvgCameraStep;